module.exports = __webpack_public_path__ + "static/img/【适配机型】电动方向盘.1728bfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type2-2/【适配机型】电动方向盘.png
// module id = bQRL
// module chunks = 0